import type { CompaniesMiniEntity } from '@/features/companies/domain/entities/CompaniesMiniEntity'
import type { MealTiersMiniEntity } from '@/features/mealTiers/domain/entities/MealTiersMiniEntity'

export class CompanyUsersFilterEntity {
  companyId?: number
  company?: CompaniesMiniEntity
  companySearchWord?: string
  userSearchWord?: string
  mealTier?: MealTiersMiniEntity
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean
}
